import { inject, Injectable } from '@angular/core'
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router'
import { Message } from '../models/message'
import { User } from '../models/user'
import { MessagingService } from '../services/messaging.service'
import { AuthStore } from '../stores/auth.store'

@Injectable()
export class HasPermission {
  private router = inject(Router)
  private authStore = inject(AuthStore)
  private messagingService = inject(MessagingService)

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    if (!route.data['permissions']) {
      return this.respond(true, state)
    } else {
      return this.authStore
        .waitForUser()
        .then((user: User | null) => {
          return this.respond(
            user
              ? route.data['permissions'].filter(
                  (p: string) => !user.hasPermission(p)
                ).length < 1
              : false,
            state
          )
        })
        .catch(() => {
          return Promise.resolve(this.respond(false, state))
        })
    }
  }

  respond(activate: boolean, state: RouterStateSnapshot) {
    if (!activate) {
      this.messagingService.broadcast(
        new Message(
          'unauthorised',
          'Unauthorised',
          'You do not have permission to access this resource',
          Message.Bad,
          Message.Medium
        )
      )
      return this.router.createUrlTree(['/'], {
        queryParams: { returnUrl: state.url },
      })
    }
    return activate
  }
}
